module.exports = __webpack_public_path__ + "media/images/official/voice_yamaguchi-762bb267686bddf44c3d5441136c347b.png";